import React, { useContext } from 'react';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import styles from './GuestAdvice.style';

export default function GuestAdvice({ adviceKey }) {
  const { state: theme } = useContext(ThemeContext);
  const { className: themeClassName, styles: themeStyle } = styles(theme);

  return theme?.guestInfo && theme.guestInfo[adviceKey] ? (
    <>
      <div className={`${themeClassName} advice-container`}>
        <div
          className={`${themeClassName} advice`}
          dangerouslySetInnerHTML={{ __html: theme.guestInfo[adviceKey] }}
        />
      </div>
      {themeStyle}
    </>
  ) : null;
}
